import { render } from "./ModalImage.vue?vue&type=template&id=edd33b3e&scoped=true&ts=true"
import script from "./ModalImage.vue?vue&type=script&lang=ts"
export * from "./ModalImage.vue?vue&type=script&lang=ts"

import "./ModalImage.vue?vue&type=style&index=0&id=edd33b3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edd33b3e"]])

export default __exports__